// extracted by mini-css-extract-plugin
export default {"button":"SmoKQF53u3UPM99YRybg"};